import { type Href, Link } from 'expo-router';
import { Checkbox, type StackProps, XStack } from 'smoothie';
import { BodySmallRegular } from 'smoothie';

interface ApexAgreementCheckboxProps extends StackProps {
    id: string;
    isChecked: boolean;
    onPress: () => void;
    linkText: string;
    linkUrl: Href;
    text: string;
}

export const ApexAgreementCheckbox = ({
    id,
    isChecked,
    onPress,
    linkText,
    linkUrl,
    text,
    ...props
}: ApexAgreementCheckboxProps) => {
    return (
        <XStack gap={8} userSelect="none" {...props}>
            <Checkbox
                onPress={onPress}
                checked={isChecked}
                id={id}
                size="default"
                tone="positive"
            />
            <XStack
                flex={1}
                cursor={onPress != null ? 'pointer' : 'default'}
                onPress={onPress}
            >
                <BodySmallRegular>
                    {text}{' '}
                    <Link
                        href={linkUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        onPress={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        <BodySmallRegular textDecorationLine="underline">
                            {linkText}
                        </BodySmallRegular>
                    </Link>
                    .
                </BodySmallRegular>
            </XStack>
        </XStack>
    );
};
